<template>
	<div>
		<p class="mb-2 fs-24 fw-bold d-none d-lg-block">DAO Power</p>
		<div class="d-flex align-items-center mb-lg-4">
			<div class="d-flex align-items-center">
				<div class="flex-shrink-0 d-none d-lg-block border border-primary-100 border-2 rounded-circle p-3 me-3">
                    <img src="/svg/dao-power-icon.svg" alt="Dao Power Icon">
				</div>
				<h1 class="fw-bold fs-64 mb-0">{{ daoPower }}%</h1>
			</div>
		</div>
        <div class="d-flex align-items-center fs-18 fw-bold d-lg-none">
            <div class="flex-shrink-0 d-lg-none border border-primary-100 border-2 rounded-circle p-2 me-2">
                <img src="/svg/dao-power-icon.svg" alt="Dao Power Icon">
            </div>
            <p class="mb-0">DAO Power</p>
            <p class="mb-0 ms-auto">{{ puzzlePoints }} <span class="text-secondary">Puzzle {{ puzzlePoints === 1 ? 'Point' : 'Points' }}</span></p>
        </div>
	</div>
</template>

<script>
export default {
	name: 'MyDaoPowerComponent',

	props: {
		daoPower: {
			type: Number
		},
		puzzlePoints: {
			type: Number
		}
	}

}
</script>
